import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useRequisicaoServicosProdutosListaFilters
 */

type State = {
  nroRequisicao: number | null;
  dataRequisicaoStart: Date | null;
  dataRequisicaoEnd: Date | null;
  centroCustos: number[] | null;
  solicitantes: number[] | null;
  status: number | null;
  produtosServicos: number[] | null;
  dataPrevistaStart: Date | null;
  dataPrevistaEnd: Date | null;
};

export const initialRequisicaoServicosProdutosListaFilters: State = {
  nroRequisicao: null,
  dataRequisicaoStart: null,
  dataRequisicaoEnd: null,
  centroCustos: null,
  solicitantes: null,
  status: 1,
  produtosServicos: null,
  dataPrevistaStart: null,
  dataPrevistaEnd: null,
};

export const useRequisicaoServicosProdutosListaFilters = create<State>((set) => ({
  ...initialRequisicaoServicosProdutosListaFilters,
}));